export default __webpack_public_path__ + "static/media/Increase_sales_sell_directly.3b2edd41.gif";